import FormatCurrency from 'components/Common/FormatCurrency'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'
import useTailorMadeTour from 'hooks/TourV2/useTailorMadeTour'
import React from 'react'

function TailorMadeTourTextualBlock() {
  const tailorMadeTour = useTailorMadeTour()

  return <VerticalSpacer gap={20}>
    <VerticalSpacer gap={16}>
      <Heading variant="heading3">Request a tailor-made tour</Heading>
      <BodyText variant="medium">Thank you for your interest! To get started, please provide your travel details below.</BodyText>
    </VerticalSpacer>
    <VerticalSpacer gap={16}>
      <Heading variant="heading4">How this works</Heading>
      <div>
        <BodyText variant="medium" weight="bold">Outline your tour details</BodyText>
        <BodyText variant="medium">
          Enter your preferred destinations, dates, and any other travel preferences in the form below.
        </BodyText>
      </div>
      <div>
        <BodyText variant="medium" weight="bold">Concierge consultation & deposit</BodyText>
        <BodyText variant="medium">
          Our concierge will call to review your itinerary and collect a fully refundable{' '}
          {!tailorMadeTour.data && <TextLoadingBox width="4ch" />}
          {tailorMadeTour.data && <FormatCurrency value={tailorMadeTour.data?.fee} />}
          {' '}deposit over the phone.
        </BodyText>
      </div>
      <div>
        <BodyText variant="medium" weight="bold">Custom itinerary creation</BodyText>
        <BodyText variant="medium">
          We’ll design a bespoke itinerary to match your preferences, managing all the details from start to finish.
        </BodyText>
      </div>
      <div>
        <BodyText variant="medium" weight="bold">Approve & finalise payment</BodyText>
        <BodyText variant="medium">
          Once you’re happy with the itinerary, your{' '}
          {!tailorMadeTour.data && <TextLoadingBox width="4ch" />}
          {tailorMadeTour.data && <FormatCurrency value={tailorMadeTour.data?.fee} />}
          {' '}deposit will be deducted from the total cost. If you choose not to proceed, your deposit will be fully refunded.
        </BodyText>
      </div>
    </VerticalSpacer>
  </VerticalSpacer>
}

export default TailorMadeTourTextualBlock
